import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  background: ${({ theme }) => theme.white};
  border-radius: 4px;
  padding: 1rem;
  width: 100%;
  max-width: 400px;
  font-weight: bold;
  text-align: left;

  .MuiInputBase-root {
    border: 1px solid rgb(204, 204, 204);
  }
`;

export const Text = styled.p`
  margin: 0;
`;

export const AreaButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

